import {useNavigate} from 'react-router';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {ROUTE_PATHS} from '@di-shared/routes';
import {DotLottieReact} from '@lottiefiles/dotlottie-react';
import {ThemeType} from '@shared/cci/features/const/environment';

interface DemeritEducationAboutProps {
  vin: string;
}

function DemeritEducationAbout({vin}: DemeritEducationAboutProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const theme = useEnvironmentStore((state) => state.theme);
  const lang = useEnvironmentStore((state) => state.lang);

  function goToAgreePage() {
    navigate(
      ROUTE_PATHS.PUBLIC_SERVICE_CONSENTS_$CATEGORY.getFullPath({
        vin,
        category: CreatePublicServiceConsentRequest.category.DEMERIT_EDUCATION,
        nextUrl: ROUTE_PATHS.HOME_FINANCE_TAB.getFullPath(vin),
      }),
      {replace: true}
    );
  }

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T10234')}</h1>
      </Header>
      <main className="content">
        <section className="section section_vehicle_intro penalty_point">
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T10235')}
              </h2>
              <p className="intro_desc">{t('T10236')}</p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                <DotLottieReact
                  className={'intro_img'}
                  src={'/assets/lottie/training_intro_01.lottie'}
                  autoplay
                  loop
                />
              </div>
            </div>
          </section>
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T10237')}
              </h2>
              <p className="intro_desc">{t('T10238')}</p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                {lang.includes('ko') ? (
                  theme === ThemeType.LIGHT ? (
                    <DotLottieReact
                      className={'intro_img'}
                      src={'/assets/lottie/training_intro_02_light.lottie'}
                      autoplay
                      loop
                    />
                  ) : (
                    <DotLottieReact
                      className={'intro_img'}
                      src={'/assets/lottie/training_intro_02.lottie'}
                      autoplay
                      loop
                    />
                  )
                ) : theme === ThemeType.LIGHT ? (
                  <DotLottieReact
                    className={'intro_img'}
                    src={'/assets/lottie/training_intro_eu_02_light.lottie'}
                    autoplay
                    loop
                  />
                ) : (
                  <DotLottieReact
                    className={'intro_img'}
                    src={'/assets/lottie/training_intro_eu_02.lottie'}
                    autoplay
                    loop
                  />
                )}
              </div>
            </div>
          </section>
        </section>
        <section className="section section_notice">
          <div className="section_container">
            <strong className="notice_title">{t('T10308')}</strong>
            <ul className="notice_list">
              <li className="notice_item">{t('T10239')}</li>
              <li className="notice_item">{t('T10307')}</li>
            </ul>
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => goToAgreePage()}
        >
          {t('T10218')}
        </button>
      </div>
    </div>
  );
}

export default DemeritEducationAbout;
